import { Applications } from './application.types';

export interface InquireFlowGptPayload {
	message: string;
	siteId: string;
	currentApp: Applications;
}
export interface InquireFlowGptResponse {
	request_id: string;
	results: {
		content: string;
		label: string;
		sources: { title: string; url: string }[];
	};
}

export enum FlowGptFeedback {
	thumbsDown = 0,
	thumbsUp = 1,
}
export interface SendFlowGptFeedbackPayload {
	conversationId: string;
	requestId: string;
	feedbackType: 'positive' | 'negative';
	comment?: string;
	reason?: string;
}
export interface SendFlowGptFeedbackResponse {
	success: boolean;
	message: string;
}
